import React from 'react';

import {
    Container,
    ContainerPicture,
    ContainerContent,
    ContainerText,
    ContainerButton,
    TextConnected,
    TextLeasing,
    Pic,
    Button,
} from './styled';

class Plank extends React.Component {
    render() {
        const { connected } = this.props;

        return (
            <Container>
                <ContainerPicture>
                    <Pic src={'/static/images/internet/antivirus/plankShield.svg'}/>
                </ContainerPicture>
                <ContainerContent>
                    <ContainerText>
                        <TextConnected>
                            У вас подключено: {connected}
                        </TextConnected>
                        <TextLeasing>
                            Каждый месяц подписка на антивирус продляется автоматически.<br/>
                            Абонентская плата спишется с вашего счета.
                        </TextLeasing>
                    </ContainerText>
                    <ContainerButton>
                        <Button text={'Управлять подписками'} type={'secondary'} href={'/'}/>
                    </ContainerButton>
                </ContainerContent>
            </Container>
        );
    }
}

export default Plank;
